import React, { useMemo } from 'react';
import GenericListPage from '../../pages/GenericListPage';
import { Link } from 'react-router-dom';

const BatchesPage = () => {
  const columns = useMemo(() => [
    { header: 'Batch', key: 'batchNumber', render: r => r.batchNumber || r.lotNumber || '—' },
    { header: 'Product', key: 'productId', render: r => (r.product?.name || r.productId || '—') },
    { header: 'Qty', key: 'quantity', render: r => r.quantity ?? 0 },
    { header: 'Purchase', key: 'purchasePrice', render: r => (r.purchasePrice != null ? Number(r.purchasePrice).toFixed(2) : '—') },
    { header: 'Sell', key: 'sellPrice', render: r => (r.sellPrice != null ? Number(r.sellPrice).toFixed(2) : '—') },
    { header: 'Expiry', key: 'expiryDate', render: r => (r.expiryDate ? new Date(r.expiryDate).toLocaleDateString() : '—') },
    { header: 'Store', key: 'storeId', render: r => (r.store?.name || r.storeId || '—') },
    { header: 'Created', key: 'createdAt', render: r => (r.createdAt ? new Date(r.createdAt).toLocaleString() : '—') },
  ], []);

  const headerActions = (
    <div className="flex items-center gap-2">
      <Link to="/batches/upload">
        <button className="bg-indigo-600 text-white px-3 py-1 rounded text-sm">+ Bulk CSV Upload</button>
      </Link>
    </div>
  );

  return (
    <GenericListPage
      title="Batches"
      permission="manage_batches"
      entityEndpoint="batches"
      columns={columns}
      // optional: provide a form component if you have one
      // FormComponent={BatchForm}
      headerActions={headerActions}
      filterConfig={[
        { name: 'productId', type: 'text', label: 'Product ID' },
        { name: 'batchNumber', type: 'text', label: 'Batch / Lot No' },
        { name: 'storeId', type: 'select', label: 'Store', endpoint: 'stores', keyField: '_id', valueField: 'name' },
      ]}
    />
  );
};

export default BatchesPage;